import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import App from './App';
import ErrorPage from './ErrorPage';
import LoginPage from './pages/Login';
import ForgotPasswordPage from './pages/ForgotPassword';
import ConfirmForgotPassword from './pages/confirmForgotPassword';
import SignupPage from './pages/SignUp';
import ConfirmPage from './pages/confirm';
import ConfirmUserPage from './pages/ConfirmUser';
import ErrorPage2 from './pages/ErrorPage';
import ChangePassword from './pages/changePassword';
import LogoutPage from './pages/logout';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const router = createBrowserRouter([
  {
    path: 'logout',
    element: <LogoutPage />,
  },
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'forgotPassword',
        element: <ForgotPasswordPage />,
      },
      {
        path: 'confirmForgotPassword',
        element: <ConfirmForgotPassword />,
      },
      {
        path: 'signUp',
        element: <SignupPage />,
      },
      {
        path: 'confirm',
        element: <ConfirmPage />,
      },
      {
        path: 'confirmUser',
        element: <ConfirmUserPage />,
      },
      {
        path: 'changePassword',
        element: <ChangePassword />,
      },
      {
        path: 'error',
        element: <ErrorPage2 />,
      },
    ],
  },
]);

root.render(
  <StrictMode>
    <ColorModeScript />
    <RouterProvider router={router} />
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
